import React, { useEffect, useState } from 'react';

import { Character } from "@dndModels";
import { AbilityScoreType } from '@dndModels/Types';

import FlexBox from '@components/layout/FlexBox';
import StringBox from '@components/input/strings/StringBox';

interface Props {
  char: Character;
}

export default function CharacterStatsCustomizations({
  char,
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [editing_stat, setEditingStat] = useState<AbilityScoreType | "">("");
  const [ping, setPing] = useState(false);

  const customizations = char.customizations;

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  const renderAbilityScoreCustomization = (ability_score: AbilityScoreType) => {
    // debugger;
    let str = ``;
    if (customizations.overrides[ability_score]) {
      str += ` (Overridden)`;
    }
    if (customizations.modifiers[ability_score]) {
      str += ` (Modified)`;
    }
    return (
      <>
        <FlexBox className="clickable" style={{ width: "33%" }} onClick={() => setEditingStat(ability_score) }>
          <FlexBox direction="column">
            <FlexBox className="header">
              { ability_score }: Current { char.mind.current_ability_scores.getAbilityScore(ability_score) }
            </FlexBox>
          </FlexBox>
          { (customizations.overrides[ability_score] || customizations.modifiers[ability_score]) && 
            <FlexBox className="small_label gray">{ str }</FlexBox>
          }
        </FlexBox>
      </>
    );
  }

  const renderSelectedField = () => {
    if (editing_stat) {
      return (
        <FlexBox direction="row">
          <FlexBox style={{ width: "33%" }}>Customizations for { editing_stat }</FlexBox>
          <FlexBox style={{ width: "33%" }}>
            <StringBox
              name="Override"
              value={customizations.overrides[editing_stat]}
              type="number"
              onBlur={(changed: string) => {
                if (changed.length === 0) {
                  delete customizations.overrides[editing_stat];
                } else {
                  customizations.overrides[editing_stat] = +changed;
                }
                setPing(!ping);
                char.changed();
                char.subscription_holder.recalculate();
              }}
            />
          </FlexBox>
          <FlexBox style={{ width: "33%" }}>
            <StringBox
              name="Modifier"
              value={customizations.modifiers[editing_stat]}
              type="number"
              onBlur={(changed: string) => {
                if (changed.length === 0) {
                  delete customizations.modifiers[editing_stat];
                } else {
                  customizations.modifiers[editing_stat] = +changed;
                }
                setPing(!ping);
                char.changed();
                char.subscription_holder.recalculate();
              }}
            />
          </FlexBox>
        </FlexBox>
      );
    }
    return null;
  }

  return (
    <FlexBox direction="column" style={{ width: "100%" }}>
      <FlexBox direction="row" style={{ width: "100%" }}>
        { renderAbilityScoreCustomization("STR") }
        { renderAbilityScoreCustomization("DEX") }
        { renderAbilityScoreCustomization("CON") }
      </FlexBox>
      <FlexBox direction="row" style={{ width: "100%" }}>
        { renderAbilityScoreCustomization("INT") }
        { renderAbilityScoreCustomization("WIS") }
        { renderAbilityScoreCustomization("CHA") }
      </FlexBox>
      { renderSelectedField() }
    </FlexBox>
  );
}

